import { LotStatusEnum, LotTypeEnum, PriorityEnum, QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("lot_info")
export class LotInfoEntity {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column('varchar',{
        name:'lot_number',
        length : 20
    })
    lotNumber : string

    @Column('enum',{
        name:'lot_type',
        enum:LotTypeEnum,
        nullable:false
    })
    lotType : LotTypeEnum


    @Column('text',{
        name:'remarks',
        nullable:false
    })
    remarks : string

    @Column('int',{
        name:'ref_no',
        nullable:false
    })
    refNo : number

    @Column('enum',{
        name:'status',
        nullable:false,
        enum:LotStatusEnum
    })
    status : LotStatusEnum

    @Column('enum',{
        name:'quality',
        nullable:true,
        enum:QualityTypeEnum
    })
    quality : QualityTypeEnum

    @Column('int',{
        name:'variant_id',
        nullable:false,
    })
    variantId : number

    @Column('decimal',{
        name:'quantity',
        nullable:true,
        precision:10,scale:3
    })
    quantity : number

    @Column('datetime',{
        name:'exfactory_date',
        nullable:true
    })
    exFactoryDate : Date

    @Column('enum',{
        name:'priority',
        enum:PriorityEnum,
        nullable:true
    })
    priority : PriorityEnum

    @Column('datetime',{
        name:'date',
        nullable:true
    })
    date : Date

    @Column('datetime',{
        name:'material_assign_date',
        nullable:true
    })
    materialAssignDate : Date

    @Column('int',{
        name:'year',
        nullable:true
    })
    year : number
    
}